import { render, staticRenderFns } from "./SetupTest.vue?vue&type=template&id=0b85d099&scoped=true&"
import script from "./SetupTest.vue?vue&type=script&lang=js&"
export * from "./SetupTest.vue?vue&type=script&lang=js&"
import style0 from "./SetupTest.vue?vue&type=style&index=0&id=0b85d099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85d099",
  null
  
)

export default component.exports